import {
  Checkbox,
  Stack,
  TextField,
  Textarea,
} from 'braid-design-system';
import React from 'react';

import { fetchVicDates } from '#src/api/vicDates';

import { EventDatePicker } from './EventDatePicker';
import type { EventFieldValues } from './eventFieldUpdates';

type EventFieldsProps = {
  eventId: string;
  fields: EventFieldValues;
  errors: Record<string, string>;
  onChange: (
    field: Exclude<keyof EventFieldValues, 'dates'>,
    value: string | boolean,
  ) => void;
  onDatesChange: (dates: string[]) => void;
};

export const EventFields = ({
  eventId,
  fields,
  errors,
  onChange,
  onDatesChange,
}: EventFieldsProps) => {
  const [vicDates, setVicDates] = React.useState<
    Awaited<ReturnType<typeof fetchVicDates>>
  >(null);

  React.useEffect(() => {
    void fetchVicDates().then(setVicDates);
  }, []);

  return (
    <Stack space="small">
      <TextField
        id={`event-title-${eventId}`}
        label="Title"
        value={fields.title}
        onChange={(e) => onChange('title', e.currentTarget.value)}
        message={errors.title}
        tone={errors.title ? 'critical' : undefined}
      />
      <Textarea
        id={`event-description-${eventId}`}
        label="Description"
        value={fields.description}
        onChange={(e) => onChange('description', e.currentTarget.value)}
        message={errors.description ?? 'Optional'}
        tone={errors.description ? 'critical' : undefined}
      />

      <EventDatePicker
        id={`event-dates-${eventId}`}
        dates={fields.dates}
        onChange={onDatesChange}
        error={errors.dates}
        vicDates={vicDates}
      />

      <Checkbox
        id={`event-highlight-${eventId}`}
        label="Show in What's next? banner"
        checked={fields.highlight}
        onChange={(e) => onChange('highlight', e.currentTarget.checked)}
      />
    </Stack>
  );
};
